import { ArrowRight } from 'lucide-react';

export default function BotonWhatsApp({ text, message = "¡Hola! Me interesa solicitar más información sobre sus sistemas." }) {
  const phoneNumber = "5492216914649";
  const encodedMessage = encodeURIComponent(message);
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="group inline-flex items-center gap-3 px-8 py-4 bg-zinc-100 text-black hover:bg-white rounded-lg transition-all duration-300 font-medium text-lg shadow-2xl shadow-white/5"
    >
      {text}
      <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
    </a>
  );
}
